import React from 'react';
import { Box } from '@wds/box';
import { MetricsTracker, USER_EVENTS } from '@sm/metrics';
import { usePricingState } from '~shared/hooks/usePricingState';
import { PackageIds, Packages, Sources } from '~shared/constants/pricing';

import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import useStyles from './useStyles';
import ACTIONS from '~shared/actions';
import { CombinedActions } from '~shared/types/pricing/actions';

export default function ToggleSwitch(): JSX.Element {
  const {
    state: {
      grow2384: { responseToggleChecked },
    },
    dispatch,
  } = usePricingState();
  const { Switch, Values, Checked } = useStyles();
  const { pageName } = useTrackingDetails();

  function handleChange(): void {
    dispatch({
      type: ACTIONS.TOGGLE_SWITCH,
      payload: { responseToggleChecked: !responseToggleChecked },
    } as CombinedActions);
    const packageSwap = {
      packageToBeReplaced: !responseToggleChecked ? PackageIds[Packages.StandardMonthly] : PackageIds[Packages.Flex],
      replacedWith: !responseToggleChecked ? PackageIds[Packages.Flex] : PackageIds[Packages.StandardMonthly],
    };
    dispatch({ type: ACTIONS.SWITCH_PACKAGES, payload: packageSwap } as CombinedActions);

    MetricsTracker.track({
      name: USER_EVENTS.ELEMENT_INTERACTION,
      data: {
        amplitudeEvent: 'experiment event',
        eventName: 'pricing clicked toggle',
        pageName,
        selectedPackage: !responseToggleChecked ? 'Standard_Monthly_100' : 'Standard_Monthly_1000',
        source: Sources.PRICINGWEB,
      },
    });
  }

  return (
    <Box className={Switch}>
      <span>Responses</span>
      <input
        role="switch"
        aria-checked="false"
        id="responseCountToggle"
        tabIndex={0}
        type="checkbox"
        checked={responseToggleChecked}
        onChange={handleChange}
      />
      <Box className={`${Values} ${responseToggleChecked ? Checked : ''}`}>
        <label htmlFor="responseCountToggle">1,000</label>
        <label htmlFor="responseCountToggle">100</label>
      </Box>
    </Box>
  );
}
